import React from 'react';
import dictionary from '../../utils/dictionary';
import ActivityLoader from '../Common/ActivityLoader';
import AlertError from './../Common/AlertError';
import TextInput from './../Common/TextInput';

class PopEditVehicleType extends React.Component {

    state = {
        typeName: '',
        info: '',
        searchList: false,
        loading: false,
        slots: '',
        itemId:'',
        item:this.props.item
    }

    componentDidMount() {
        const item=this.state.item;
        this.setState({
            typeName:item.type_name,
            slots:item.slots,
            itemId:item.type_id
        })
    }
    

    onChangeTypeName = (event) => {
        this.setState({ typeName: event.target.value });
    }

    onChangeSlots = (event) => {
        this.setState({ slots: event.target.value });
    }

    onConfirm = (event) => {
        event.preventDefault();
        const { typeName, slots, itemId } = this.state;
        if (typeName.length > 0 && slots.length>0 && itemId>0) {
            this.setState({
                loading: true
            })
            this.props.onConfirm(itemId, typeName, slots);
        } else {
            this.setState({
                info: <AlertError message={dictionary._completeFields} />
            })
        }
    }



    render() {
        return (
            <div className="modal" id="modal_edit_car_type">
                <div className="modal-dialog modal-dialog-centered" role="document">


                    <div className="modal-content modal-content-demo shadow">
                        <div className="modal-header">
                            <h6 className="modal-title">Edit Vehicle Type</h6>
                            <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            {this.state.info}
                            <form method="post" onSubmit={this.onConfirm}>

                                <TextInput
                                    label="Type Name"
                                    type="text"
                                    onChange={() => this.onChangeTypeName}
                                    value={this.state.typeName}
                                />
                                <TextInput
                                    label="No. of slots"
                                    type="number"
                                    onChange={() => this.onChangeSlots}
                                    value={this.state.slots}
                                />

                            </form>



                        </div>
                        <div className="modal-footer">
                            {!this.state.loading && <>
                                <button className="btn ripple btn-primary" type="button" onClick={this.onConfirm}>Save Changes</button>
                                <button className="btn ripple btn-secondary" type="button" data-dismiss="modal">Close</button>
                            </>}

                            {this.state.loading && <ActivityLoader />}
                        </div>
                    </div>


                </div>
            </div>
        )


    }
}

export default PopEditVehicleType;
